import React from 'react'

import circles from '../../assets/images/payroll-cards/accordion-circles.svg'
import SlideImage from '../../components/slide-image/SlideImage'
import RedCardBlock from '../../components/red-card-block/RedCardBlock'
import Footnote from '../../components/footnote/Footnote'
import AnimatedDollars from '../../components/animated-dollars/AnimatedDollars'
import SlideCarousel from '../../components/SlideCarousel'
import { PayrollCardsAccordion, PayrollCardsBenefits, PayrollCardsHeader, PayrollCardsProgram } from './components'
import useStyles from './PayrollCards.styles'

export default function PayrollCards () {
  const classes = useStyles()

  return (
    <div>
      <PayrollCardsHeader />
      <PayrollCardsProgram />
      <PayrollCardsAccordion />
      <SlideImage
        title={
          <h2>
            Streamlined for Employers, Loved by Employees
          </h2>
        }
        text={
          <ul>
            <li style={{ marginBottom: 16 }}>
              <b>No Change to Your Payroll Process:</b> Send payroll just like always.
            </li>
            <li style={{ marginBottom: 16 }}>
              <b>Fully Compliant:</b> Built with regulatory compliance in mind, including support for unbanked workers.
            </li>
            <li style={{ marginBottom: 16 }}>
              <b>Turnkey Setup:</b> Fast onboarding, full support, and minimal disruption.
            </li>
          </ul>
        }
        textPosition='left'
        image={circles}
        imageDisclaimer='³ FDIC National Survey of Unbanked and Underbanked Households, 2021, Table 1.1'
        button={false}
      />
      <PayrollCardsBenefits />
      <RedCardBlock title='Get Started Today?' buttonText='Leave us a message' subtitle='Contact us to set up your program.' />
    </div>
  )
}
